<template>
  <div class="sub-page-title-area" :class="areaModifiers">
    <div v-if="icon" class="title-area_icon_img">
      <img :src="icon" :alt="iconAlt" />
    </div>
    <h2 class="sub-page-title" :class="titleModifier">
      <slot>{{ title }}</slot>
    </h2>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sub-page-title-area`（下層ページの見出し）。23〜26本に出る。
 *
 * 修飾子は2つあり、支給では独立して付く。
 * - `title-area_icon`（39本）… 見出しの左にアイコン画像を置く。**`icon` を渡すと自動で付く**
 * - `title-area-underline` … 見出しの下に罫線を引く。既定で付ける（支給の下層ページはほぼ全て持つ）
 *
 * `h2` 側にもページ別の修飾クラスが付く（`my-page-title` / `shopping-guide-title` など）。
 * 支給CSSがそのクラスで余白と文字サイズを変えるので、`titleModifier` で渡せるようにする。
 *
 * アイコンの `alt` は既定で空にする。見出しの文字が隣にあり、画像は装飾のため
 * （支給は `alt="お買い物ガイドアイコン"` と入れているが、読み上げが二重になる）。
 */
type Props = {
  /** 見出しの文字。スロットを使う場合は省略できる */
  title?: string;
  /** アイコン画像のパス。渡すと `title-area_icon` が付く */
  icon?: string;
  iconAlt?: string;
  /** `h2` に足す修飾クラス（`my-page-title` など） */
  titleModifier?: string;
  /** `title-area-underline` を付けるか */
  underline?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  title: '',
  icon: '',
  iconAlt: '',
  titleModifier: '',
  underline: true,
});

const areaModifiers = computed<string[]>(() => [
  ...(props.icon ? ['title-area_icon'] : []),
  ...(props.underline ? ['title-area-underline'] : []),
]);
</script>
